(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function t4sCloneRichTextByWords(sourceEl, previewEl, moreEl, limit) {
    var usedWords = 0;
    var hasMore = false;

    function splitTextNode(text) {
      if (!text) {
        return { preview: '', more: '' };
      }

      var tokens = text.match(/\s+|\S+/g) || [];
      var previewText = '';
      var moreText = '';

      tokens.forEach(function(token) {
        var isSpace = /^\s+$/.test(token);

        if (isSpace) {
          if (usedWords < limit) {
            previewText += token;
          } else if (hasMore) {
            moreText += token;
          }
          return;
        }

        if (usedWords < limit) {
          previewText += token;
          usedWords += 1;
        } else {
          moreText += token;
          hasMore = true;
        }
      });

      return {
        preview: previewText,
        more: moreText
      };
    }

    function cloneNodeToTargets(node, previewParent, moreParent) {
      if (node.nodeType === Node.TEXT_NODE) {
        var split = splitTextNode(node.textContent);

        if (split.preview) {
          previewParent.appendChild(document.createTextNode(split.preview));
        }

        if (split.more) {
          moreParent.appendChild(document.createTextNode(split.more));
        }

        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      var tagName = node.tagName.toLowerCase();
      if (tagName === 'script' || tagName === 'style') return;

      var previewClone = node.cloneNode(false);
      var moreClone = node.cloneNode(false);

      Array.prototype.slice.call(node.childNodes).forEach(function(child) {
        cloneNodeToTargets(child, previewClone, moreClone);
      });

      if (previewClone.textContent.trim() || previewClone.querySelector('img,svg,br')) {
        previewParent.appendChild(previewClone);
      }

      if (moreClone.textContent.trim() || moreClone.querySelector('img,svg,br')) {
        moreParent.appendChild(moreClone);
      }
    }

    function rawText(node) {
      return (node && node.textContent) ? node.textContent : '';
    }

    function needsSpaceBetween(leftNode, rightNode) {
      var leftRaw = rawText(leftNode);
      var rightRaw = rawText(rightNode);

      if (!leftRaw || !rightRaw) return false;
      if (/\s$/.test(leftRaw) || /^\s/.test(rightRaw)) return false;

      var left = leftRaw.replace(/\s+$/g, '');
      var right = rightRaw.replace(/^\s+/g, '');
      var last = left.slice(-1);
      var first = right.charAt(0);

      if (!last || !first) return false;
      if (/^[.,;:!?%\])}]/.test(first)) return false;
      if (/[([{]$/.test(last)) return false;

      return true;
    }

    function normalizeInlineSpacing(parent) {
      if (!parent) return;

      var nodes = Array.prototype.slice.call(parent.childNodes);

      for (var i = 0; i < nodes.length - 1; i++) {
        var current = nodes[i];
        var next = nodes[i + 1];

        if (needsSpaceBetween(current, next)) {
          parent.insertBefore(document.createTextNode(' '), next);
        }
      }

      Array.prototype.slice.call(parent.children).forEach(function(child) {
        normalizeInlineSpacing(child);
      });
    }

    function ensurePreviewMoreBoundarySpace() {
      if (!hasMore || !previewEl || !moreEl || !moreEl.firstChild) return;

      if (needsSpaceBetween(previewEl, moreEl)) {
        moreEl.insertBefore(document.createTextNode(' '), moreEl.firstChild);
      }
    }

    previewEl.innerHTML = '';
    moreEl.innerHTML = '';

    Array.prototype.slice.call(sourceEl.childNodes).forEach(function(node) {
      cloneNodeToTargets(node, previewEl, moreEl);
    });

    normalizeInlineSpacing(previewEl);
    normalizeInlineSpacing(moreEl);
    ensurePreviewMoreBoundarySpace();

    return hasMore;
  }

  function t4sInitCollectionDescriptionToggle() {
    document.querySelectorAll('[data-collection-desc-toggle]').forEach(function(wrapper) {
      if (wrapper.dataset.initialized === 'true') return;

      var source = wrapper.querySelector('.t4s-collection-desc-toggle__source');
      var preview = wrapper.querySelector('.t4s-collection-desc-toggle__preview');
      var more = wrapper.querySelector('.t4s-collection-desc-toggle__more');
      var dots = wrapper.querySelector('.t4s-collection-desc-toggle__dots');
      var button = wrapper.querySelector('.t4s-collection-desc-toggle__button');
      var limit = parseInt(wrapper.getAttribute('data-limit'), 10) || 150;

      if (!source || !preview || !more || !button) return;

      var hasMore = t4sCloneRichTextByWords(source, preview, more, limit);

      if (!hasMore) {
        if (dots) dots.style.display = 'none';
        button.style.display = 'none';
        more.setAttribute('hidden', 'hidden');
      } else {
        if (dots) dots.style.display = 'inline';
        button.style.display = 'inline';
        more.setAttribute('hidden', 'hidden');
      }

      wrapper.dataset.initialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', t4sInitCollectionDescriptionToggle);
  document.addEventListener('shopify:section:load', t4sInitCollectionDescriptionToggle);

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.t4s-collection-desc-toggle__button');
    if (!button) return;

    var wrapper = button.closest('[data-collection-desc-toggle]');
    if (!wrapper) return;

    var moreText = wrapper.querySelector('.t4s-collection-desc-toggle__more');
    var dots = wrapper.querySelector('.t4s-collection-desc-toggle__dots');
    var isExpanded = button.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      if (moreText) moreText.setAttribute('hidden', 'hidden');
      if (dots) dots.style.display = 'inline';

      button.setAttribute('aria-expanded', 'false');
      button.textContent = button.getAttribute('data-show-more-text') || 'Show More';
    } else {
      if (moreText) moreText.removeAttribute('hidden');
      if (dots) dots.style.display = 'none';

      button.setAttribute('aria-expanded', 'true');
      button.textContent = button.getAttribute('data-show-less-text') || 'Show Less';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
